import {loadLazy} from 'uix/parts'

const Interpreter = loadLazy(() => import(/* webpackChunkName: 'interpreter' */ './interpreter'))
export default Interpreter
